import jwt_decode from "jwt-decode";
import { store } from "../redux/store";
import * as actions from "../redux/actions/auth.action";
import { withPreservedQuery, PRESERVE_ALL_QUERY_PARAMS, isWebViewQueryActive } from "../modules/newProviderApp/actions/webviewQuery";

export function buildStsTokenManager({ accessToken, refreshToken, idToken, expiresIn, username }) {
   let expirationTime;

   try {
      expirationTime = jwt_decode(accessToken).exp;
   } catch (error) {
      expirationTime = expiresIn ? Math.floor(Date.now() / 1000) + expiresIn : undefined;
   }

   let resolvedUsername = username;
   if (!resolvedUsername && idToken) {
      try {
         const claims = jwt_decode(idToken);
         resolvedUsername = claims.email || claims["cognito:username"] || claims.sub;
      } catch (error) {
         resolvedUsername = undefined;
      }
   }

   return {
      accessToken,
      refreshToken,
      idToken,
      provider: "cognito",
      expirationTime,
      username: resolvedUsername,
   };
}

export function saveAuthSession({ stsTokenManager, userData }) {
   const northwelluser = {
      user: {
         stsTokenManager,
         email: userData?.email,
         displayName: userData?.name || userData?.fullName,
      },
      operationType: "signIn",
   };

   store.dispatch(actions.savenorthwelluserobj(northwelluser));

   if (userData) {
      store.dispatch(actions.saveusercredentials({ user: userData }));
   }
}

export function getNorthwellUser() {
   const northwelluser = store.getState().auth?.northwelluser;

   if (typeof northwelluser === "string") {
      try {
         return JSON.parse(northwelluser);
      } catch (error) {
         return null;
      }
   }

   return northwelluser;
}

export function getStsTokens() {
   return getNorthwellUser()?.user?.stsTokenManager;
}

export function getUserEmail() {
   return (
      store.getState().auth?.loggedInProviderDetails?.email
   );
}

export function saveStsTokens(stsTokenManager) {
   const northwelluser = getNorthwellUser();

   if (!northwelluser?.user) {
      return;
   }

   northwelluser.user.stsTokenManager = stsTokenManager;
   store.dispatch(actions.savenorthwelluserobj(northwelluser));
}

export function forceReauth() {
   const persistWebView =
      localStorage.getItem("isLoadedOnWebView") === "true" ||
      new URLSearchParams(window.location.search).get("webview") === "true";
   let loginPath = "/login";
   if (persistWebView) {
      loginPath =
         PRESERVE_ALL_QUERY_PARAMS && isWebViewQueryActive()
            ? withPreservedQuery("/login", { fallbackWebView: true })
            : "/login?webview=true";
   }
   sessionStorage.clear();
   localStorage.clear();
   window.location.replace(loginPath);
}
